import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()((theme: Theme) => ({
  root: {
    '& h1': {
      textTransform: 'uppercase',
      color: theme.palette.primary.main
    },
    '& h2': {
      textAlign: 'center'
    }
  },
  label: {
    color: theme.palette.disabled.contrastText,
    lineHeight: '140%'
  },
  divider: {
    borderColor: theme.palette.black.main
  }
}))
